var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"listOfSections",class:['additional_dropdown__menu', _vm.isLeft ? 'left-position' : '']},_vm._l((_vm.fieldsToRender),function(section){return _c('b-dropdown-item',{key:section.id,on:{"click":function($event){return _vm.moveItemToSection(section.id)}}},[_vm._v(" "+_vm._s(section.Name)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }